import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path fill-rule="evenodd" d="m16.275 4.079 13 3.714a1 1 0 0 1 .725.961V11a1 1 0 0 1-1 1h-1v12h1a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h1V12H3a1 1 0 0 1-1-1V8.754a1 1 0 0 1 .725-.961l13-3.714a1 1 0 0 1 .55 0zm.862 11.666c2.705.58 3.863 1.57 3.863 3.318 0 2.339-2.126 3.358-4.263 3.558V23c0 .552-.471.999-1.053.999-.581 0-1.052-.447-1.052-1v-.429c-1.528-.077-2.885-.95-3.527-2.269a1.32 1.32 0 0 1-.105-.49c0-.529.421-.849 1.053-.849.463-.027.89.237 1.052.65.761 1.066 2.085 1.64 3.432 1.489 1.463-.08 2.337-.82 2.337-1.759 0-.94-.632-1.439-2.327-1.829l-1.694-.36c-2.548-.54-3.737-1.538-3.737-3.317 0-1.779 1.379-3.048 3.568-3.398V10c0-.552.472-.999 1.053-.999s1.053.447 1.053 1v.39c1.936.209 3.378 1.098 3.81 2.387.056.158.085.324.084.49 0 .45-.368.74-.958.74a1.153 1.153 0 0 1-1.052-.64c-.679-1.014-1.898-1.581-3.158-1.469-1.316.13-2.221.82-2.221 1.699 0 .88.62 1.429 2.105 1.789l1.737.36z" clip-rule="evenodd" stroke="none"></path>';
export var BankSVG = function BankSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
BankSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BankSVG);